export default __webpack_public_path__ + "static/media/SetupAccount.9c4292c6.jpg";